import React from "react";
import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "@/modules/auth/hooks/useAuth";
import { FullScreenLoader } from "@/shared/components/FullScreenLoader";

interface PrivateRoutesProps {
  children: ReactNode;
  to?: string;
}

export const PrivateRoute: React.FC<PrivateRoutesProps> = ({ children, to = "/auth" }) => {
  const { isAuthenticated, isInitialized, user } = useAuth();
  const location = useLocation();

  // Gate on isInitialized, never isLoading — isLoading also toggles during login
  // submission and would unmount mounted children mid-flow.
  if (!isInitialized) {
    return <FullScreenLoader />;
  }

  if (!isAuthenticated) {
    // The login brings the person back here: a shortcut or a link opened after the session expired.
    return <Navigate to={to} replace state={{ from: `${location.pathname}${location.search}` }} />;
  }

  // Bloqueante: authenticated but email not yet verified → force the verify screen.
  if (user && !user.email_verified_at) {
    return <Navigate to="/auth/register/verify" replace />;
  }

  return <>{children}</>;
};
